import * as React from 'react'
import SearchIcon from '@mui/icons-material/Search';


type Props = {
  onValueChanged: (value: string) => void
}


const RankingSearchBox: React.FC<Props> = ({ onValueChanged }) => {
  const [value, setValue] = React.useState<string>('');

  React.useEffect(() => {
    onValueChanged(value);
  }, [value]);

  return (
    <div className='relative text-xl'>
    <input className='w-full py-4 pl-20 
    focus:bg-gray-100 hover:bg-gray-100
    dark:focus:bg-gray-900 dark:hover:bg-gray-900 bg-transparent outline-none 
    border-b  border-viking-700
    ' type="text" placeholder="Filter node by label or id" onChange={e => {
      setValue(e.target.value);
    }} />
    <SearchIcon color="inherit" fontSize="inherit" className='absolute top-0 left-0 ml-8 mt-5 text-gray-400 text-2xl' />
    </div>
  );
}

export default RankingSearchBox;

